import { Suspense, useEffect } from 'react'
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom'
import styled from 'styled-components/macro'
import { Grid } from '@mui/material'
import { isAuthenticated } from '@tomfxs/permissions-client'

import { Sidebar } from 'src/components/Sidebar/Sidebar'
import { Topbar } from 'src/components/Topbar/Topbar'
import { PrivacyAgreement } from 'src/components/PrivacyAgreement/PrivacyAgreement'
import { Router } from './Router'
import { LoginRoute } from 'src/routes/login/LoginRoute'
import { SetPasswordRoute } from 'src/routes/login/SetPasswordRoute'
import { AuthenticationProvider } from 'src/context/AuthenticationContext'

import Breadcrumbs from 'src/components/Breadcrumbs'
import { spacing } from 'src/utils/styled'

const RootContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
`

const ContentContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-top: ${spacing(8)};
`

const RoutesContainer = styled.div``

const FooterSpacer = styled.div`
    width: 100%;
    height: ${spacing(6)};
`

export function App() {
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (!isAuthenticated('x-mp-auth') && location.pathname !== '/login' && location.pathname !== '/set-password') {
            navigate('/login')
        }
    }, [location.pathname, navigate])

    return (
        <Suspense fallback={<></>}>
            <RootContainer>
                <Routes>
                    <Route path="/login" element={<LoginRoute />} />
                    <Route path="/set-password" element={<SetPasswordRoute />} />
                    <Route
                        path="*"
                        element={
                            <AuthenticationProvider>
                                <PrivacyAgreement />
                                <Topbar />
                                <Sidebar />
                                <ContentContainer>
                                    <Grid container overflow={'auto'}>
                                        <Grid item xs={12}>
                                            <Breadcrumbs />
                                            <RoutesContainer>
                                                <Suspense fallback={<></>}>
                                                    <Router />
                                                </Suspense>
                                                <FooterSpacer />
                                            </RoutesContainer>
                                        </Grid>
                                    </Grid>
                                </ContentContainer>
                            </AuthenticationProvider>
                        }
                    />
                </Routes>
            </RootContainer>
        </Suspense>
    )
}
